// msalConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (level === 0) console.error(message);
        else if (level === 1) console.warn(message);
        else if (level === 2) console.info(message);
        else if (level === 3) console.debug(message);
      },
      piiLoggingEnabled: false,
      logLevel: 3, // Cambia a 0 para errores, 3 para todos los mensajes
    },
  },
};
